import { getStateThemes } from './getStateThemes';
import { ELEMENT_CATEGORIES, STATES } from './constants';

export { ELEMENT_CATEGORIES, STATES };

export default getStateThemes;
